export default function Loading(
  props: { message?: string; size?: "sm" | "md" | "lg" } = { size: "lg" },
) {
  return (
    <div className="flex items-center justify-center self-center">
      <div className="text-center">
        <div className="flex-col gap-4 w-full flex items-center justify-center">
          <div
            className={`w-20 h-20 border-4 border-transparent text-red-600 text-4xl animate-spin flex items-center justify-center border-t-red-600 rounded-full ${props.size === "sm" ? "w-9 h-9 text-xl" : props.size === "md" ? "w-12 h-12 text-2xl" : "w-20 h-20 text-4xl"}`}
          >
            <div
              className={`w-16 h-16 border-4 border-transparent text-black text-2xl animate-spin flex items-center justify-center border-t-black rounded-full ${props.size === "sm" ? "w-6 h-6 text-md" : props.size === "md" ? "w-11 h-11 text-xl" : "w-16 h-16 text-2xl"}`}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}
